import Template from "./template";

export default {
  path: ":viewName/:id",
  element: <Template />,
  loader: async ({ params }) => {
    const { viewName, id } = params;

    return {
      viewName,
      id,
    };
  },
};
